import {
  CartesianGrid,
  Line,
  LineChart,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from "recharts";

export default function IndexLineChart({ delivery_chart }) {
  if (!delivery_chart) return null;

  const chartData = delivery_chart.labels.map((day, index) => ({
    day,
    orders: delivery_chart.orders[index],
    delivered: delivery_chart.delivered[index],
    revenue: delivery_chart.revenue[index],
  }));

  return (
    <div className="card rounded-4 shadow-sm">
      <div className="card-body">
        <h5 className="fw-bold">الأداء اليومي (آخر 7 أيام)</h5>

        <ResponsiveContainer width="100%" aspect={1.618}>
          <LineChart data={chartData}>
            <CartesianGrid stroke="#eee" strokeDasharray="5 5" />

            <XAxis dataKey="day" />
            <YAxis domain={[0, delivery_chart.max]} />

            <Line
              type="monotone"
              dataKey="orders"
              stroke="#FFCC03"
              strokeWidth={2}
              name="الطلبات"
            />

            <Line
              type="monotone"
              dataKey="delivered"
              stroke="#0d6efd"
              strokeWidth={2}
              name="تم التوصيل"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
